<template>
    <div class="blog-news-carousel">
        <div class="blog-item" v-for="(card , index) in posts.slice(0,3)" :key="card.id">
            <BlogCard
                    :cat-title="card.categoria.name"
                    :flag="card.categoria.color"
                    :id="card.id"
                    :img="card.file"
                    :sidebar="true"
                    :offset="index"
                    :title="card.title"
                    :desc="card.text"/>
        </div>
    </div>
</template>

<script>
    import BlogCard from "../../Shared/BlogCard";

    export default {
        name: "BlogNewsCarousel",
        props: ['blogPage', 'footer'],
        data() {
            return {
                posts: [],
            }
        },
        methods: {
            fetchPosts() {
                axios.get('/blog')
                    .then(r => {
                        this.posts = r.data.data.reverse();
                    })
            }
        },
        mounted() {
            this.fetchPosts();
        },
        components: {
            BlogCard,
        }
    }
</script>

<style lang="scss" scoped>
    .blog-news-carousel {
        max-width: 1140px;
        margin: 40px auto 0 auto;

        &__title {
            font-family: Poppins, Arial, sans-serif;
            font-weight: 500;
            font-size: 1.75rem;
            color: #fff;
            padding-top: 60px;
            margin-bottom: 40px;
        }
    }

    .black {
        color: #2b2b2b;
    }

    .blog-item {
        margin: 30px 0;
    }
</style>